import * as L from 'leaflet';
/**
 * The default meteotest layer url template.
 * 512 only used for mapbox
 */
export const MT_LAYER_URL_TEMPLATE = 'https://{service}/{mapId}/tiles/512/{z}/{x}/{y}?access_token={token}';
/**
 * The default meteotest layer mapbox service path.
 */
export const MT_LAYER_SERVICE = 'api.mapbox.com/styles/v1';
/**
 * Default mapbox options are to increase tileSize to 512
 * https://meteotest.atlassian.net/browse/MAAP-241
 */
const MAPBOX_DEFAULT_OPTIONS = {
    tileSize: 512,
    // zoomOffset: -1 hack is required for 512px tiles, because Leaflet's default
    // is 256px. Without this, the map's georeferencing is broken.
    // Cf. https://github.com/Leaflet/Leaflet/issues/4391#issuecomment-207411719
    zoomOffset: -1,
};
/**
 * Meteotest default layer constructor.
 */
export class MTLayer extends L.TileLayer {
    /**
     * Create a new instance of MtLayer.
     * @param token - The access token.
     * @param options - The tile layer options.
     */
    constructor(token, options) {
        super(MT_LAYER_URL_TEMPLATE, Object.assign(Object.assign({ service: MT_LAYER_SERVICE, token: token }, MAPBOX_DEFAULT_OPTIONS), options));
    }
}
//# sourceMappingURL=MtLayer.js.map